function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { of } from "rxjs";
import { flatMap, map } from "rxjs/operators";
import ExchangeDataProvider from "../../TradeLib/ExchangeDataProvider";
import { $st } from "../../utils/i18n";
var DisableBase = {
  HUSD: true
};
var AIPTradeHelper = /*#__PURE__*/function () {
  function AIPTradeHelper(tradeSelectInfo) {
    _classCallCheck(this, AIPTradeHelper);
    _defineProperty(this, "tradeSelectInfo", void 0);
    this.tradeSelectInfo = tradeSelectInfo;
  }
  _createClass(AIPTradeHelper, [{
    key: "querySupportSymbols",
    value:
    /**
     * 查询支持的币对map，key是symbol.base
     */
    function querySupportSymbols() {
      return this.getDataProvider().pipe(flatMap(function (provider) {
        return provider.getExchangeSymbols();
      }), map(function (symbols) {
        var supportSymbols = new Map();
        var supportQuote = "USDT";
        symbols.forEach(function (element) {
          var quote = element.quote.toUpperCase();
          if (quote === supportQuote) {
            var base = element.base.toUpperCase();
            if (!DisableBase[base]) {
              supportSymbols.set(base, element);
            }
          }
        });
        return supportSymbols;
      }));
    }
  }, {
    key: "getDataProvider",
    value: function getDataProvider() {
      var _this = this;
      return of("").pipe(flatMap(function () {
        if (!_this.tradeSelectInfo.apiKey) {
          throw $st("trade_create_order_get_apikey_failed");
        }
        return ExchangeDataProvider.getExchangeDataProvider(_this.tradeSelectInfo.apiKey);
      }));
    }
  }], [{
    key: "queryLimitData",
    value: function queryLimitData(exchange, symbol) {
      return ExchangeDataProvider.getPublicExchangeDataProvider(exchange).api.queryAipLimit(symbol, exchange).pipe(map(function (res) {
        if (!res) {
          throw "queryAipLimit no result";
        }
        return res;
      }));
    }
  }, {
    key: "queryAIPYield",
    value: function queryAIPYield(exchange, base) {
      return ExchangeDataProvider.getPublicExchangeDataProvider(exchange).api.queryAipBackTest(base, "USDT", exchange).pipe(map(function (res) {
        if (!res) {
          throw "queryAIPYield no result";
        }
        return res;
      }));
    }
  }]);
  return AIPTradeHelper;
}();
_defineProperty(AIPTradeHelper, "insvestmentPerWeek", function (investmentEachTime, timeInterval) {
  return investmentEachTime / timeInterval * 60 * 60 * 24 * 7;
});
export default AIPTradeHelper;